/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { AgentIcon, agentSelect, Wrapper } from './styled';
import Select from 'react-select';
import { ThemeContext } from 'Context';
import { useDispatch } from 'react-redux';
import { getAgentsExecutions } from 'store/Agents/actions';

const AgentSelector = () => {
  const dispatch = useDispatch();
  const { themeStyles } = useContext(ThemeContext);
  const [agentType, setAgentType] = useState('agent_executions');

  const onChange = (e) => setAgentType(e.value);

  const options = [
    {
      label: 'Runners',
      value: 'agent_executions'
    },
    {
      label: 'Security Scanners',
      value: 'cloud_agent_executions'
    }
  ];

  const labels = {
    agent_executions: 'Runners',
    cloud_agent_executions: 'Security Scanners'
  };

  useEffect(() => {
    dispatch(getAgentsExecutions());
  }, [agentType]);

  return (
    <Wrapper>
        <AgentIcon />
        <Select
          isDisabled
          styles={ agentSelect(themeStyles) }
          isSearchable={ false }
          value={ { label: labels[agentType], value: agentType } }
          onChange={ (e) => onChange(e) }
          options={ options }
        />
    </Wrapper>
  );
};

export default AgentSelector;
